import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Plot from "react-plotly.js";
import createDownloadCSV from "../../utility/exportCSV/exportCsv";
import ReactLoading from "react-loading";
import "../../css/FifteenMinuteTrending.css";
import "../../css/custom.css";
import { FifteenMinuteParser, FacilityParser } from "../../parser/TrendingAnalysis";
import BootstrapTable from "react-bootstrap-table-next";
import VoltageTypeSelect from "../../components/TopNav/components/VolatgeTypeSelect/VoltageTypeSelect";

const FacilityPQPlot = ({ tabData, setTabData }) => {
    const [showBlurEffect, setShowBlurEffect] = useState(false);
    const [classForCssBlurOnPlot, SetClassForCssBlurOnPlot] = useState("");
    const [tableData, setTableData] = useState({
        data: [],
        columns: [{ dataField: "", text: "" }],
        keyField: "measurement",
    });
    const [plotData, setPlotData] = useState({
        data: [],
        layout: {},
    });

    useEffect(() => {
        if (tabData.showPlot) {
            const { plot, table } = FacilityParser.parseData(tabData.plotData, tabData.plotMetaData);
            setPlotData(plot);
            setTableData(table);
        }
    }, [tabData]);

    const onPlotCloseButtonClick = () => {
        setTabData((prevData) => {
            return {
                ...prevData,
                showPlot: false,
            };
        });
    };

    const onDownloadCsvButtonClick = () => {
        // Remove the duplicate filler traces and the np+sf bar
        const filterdData = plotData.data.filter((value) => {
            if (value.connectgaps) return false;
            if (value.name == "NP + SF") return false;
            return true;
        });

        const timestamps = filterdData[0].x;

        const columns = ["Timestamp", ...filterdData.map((trace) => trace.csvName)];

        const rows = timestamps.map((timestamp, i) => [
            timestamp,
            ...filterdData.map((trace) => ("customdata" in trace ? trace.customdata[i] : trace.y[i])),
        ]);

        const csvString = [columns.join(","), ...rows.map((row) => row.join(","))].join("\n");

        const csvFileName = tabData.plotMetaData.selectedFacility.label + " Facility PQ Plot.csv";

        createDownloadCSV(csvString, csvFileName);
    };

    useEffect(() => {
        if (tabData.isPlotLoading) {
            const plotDataArea = document.querySelector(".facilityPQPlot");
            plotDataArea.scrollIntoView({ block: "start", behavior: "smooth" });
            setShowBlurEffect(true);
            // SetClassForCssBlurOnPlot("plot-loading-bars-15-Minute-Trending-page-for-Trending-Analysis");
            return;
        }
        setShowBlurEffect(false);
    }, [tabData.isPlotLoading]);

    return (
        <Card className="facilityPQPlot">
            {showBlurEffect && (
                <row className={"plot-loading-bars"}>
                    <div>
                        <ReactLoading type="bars" color="#007bff" height={120} width={120} />
                    </div>
                </row>
            )}
            <Card.Header>
                <Row>
                    <Col className="col-9">
                        <h3 className="display-inline">Facility PQ Plot</h3>
                        <Button className="export-csv-button" onClick={onDownloadCsvButtonClick}>
                            Export Csv
                        </Button>
                    </Col>
                    <Col className="col-2">
                        <VoltageTypeSelect />
                    </Col>
                    <Col className="co-1 align-right">
                        <Button variant="secondary" onClick={onPlotCloseButtonClick} className="x_button">
                            X
                        </Button>
                    </Col>
                </Row>
            </Card.Header>
            <Row className="min_table_row justify-content-md-center">
                <Col className="min_table_CSS ">
                    <BootstrapTable keyField={tableData.keyField} data={tableData.data} columns={tableData.columns} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Plot
                        data={plotData.data}
                        layout={plotData.layout}
                        config={{
                            displaylogo: false,
                            modeBarButtonsToRemove: [
                                "zoom2d",
                                "pan2d",
                                "select2d",
                                "lasso2d",
                                "zoomIn2d",
                                "zoomOut2d",
                                "autoScale2d",
                                "toggleSpikelines",
                                "hoverClosestCartesian",
                                "hoverCompareCartesian",
                            ],
                        }}
                        useResizeHandler
                        className="plotCSS"
                    />
                </Col>
            </Row>
        </Card>
    );
};

export default React.memo(FacilityPQPlot);
